export function getAvgSpendGuestChartData({
  objects,
  selectedStoreCode,
  selectedMonthName,
  selectedYear,
}) {
  // 1) Filter completed transactions and apply year/month/store filters
  let filtered = (objects || []).filter((tx) => tx.status === "C");
  filtered = filtered.filter((sale) => {
    const d = new Date(sale.tran_date);
    const year = d.getFullYear();
    const month = d.toLocaleString("default", { month: "long" });
    const store = sale.store_code.replace("ANGELSPIZZA_", "");

    const okYear = selectedYear ? year === parseInt(selectedYear, 10) : true;
    const okMonth = selectedMonthName ? month === selectedMonthName : true;
    const okStore = selectedStoreCode ? store === selectedStoreCode : true;

    return okYear && okMonth && okStore;
  });

  // 2) Aggregate sales and customer counts by month
  const salesByMonth = {};
  const countsByMonth = {};

  filtered.forEach((sale) => {
    if (sale.cust_name && sale.cust_name !== "-") {
      const d = new Date(sale.tran_date);
      const month = d.toLocaleString("default", { month: "long" });
      const year = d.getFullYear();
      const key = `${month} ${year}`;

      salesByMonth[key] = salesByMonth[key] || [];
      countsByMonth[key] = countsByMonth[key] || {};

      salesByMonth[key].push(sale);
      countsByMonth[key][sale.cust_name] =
        (countsByMonth[key][sale.cust_name] || 0) + 1;
    }
  });

  // 3) Compute totals, counts, and averages per month
  const labels = Object.keys(salesByMonth);
  const monthlyTotals = labels.map((key) => {
    return salesByMonth[key].reduce((sum, sale) => {
      const total = parseFloat(sale.total) || 0;
      const discount = parseFloat(sale.discount_amount) || 0;
      const tax = parseFloat(sale.total_tax) || 0;
      const gross = total + discount + tax;
      return sum + gross;
    }, 0);
  });
  const monthlyCounts = labels.map((key) => {
    return Object.values(countsByMonth[key]).reduce((sum, c) => sum + c, 0);
  });
  const monthlyAverages = monthlyTotals.map((tot, i) =>
    monthlyCounts[i] ? tot / monthlyCounts[i] : 0
  );

  // 4) Return Chart.js data structure
  return {
    labels,
    datasets: [
      {
        type: "line",
        label: "Avg Spend per Guest",
        data: monthlyAverages,
        borderColor: "#ffd043",
        borderWidth: 2,
        fill: false,
        yAxisID: "y-axis-2",
      },
      {
        type: "bar",
        label: "Guest Count",
        data: monthlyCounts,
        backgroundColor: "#006096",
        yAxisID: "y-axis-1",
      },
    ],
  };
}

/**
 * Build Chart.js options for dual-axis Avg Spend vs Guest Count chart.
 *
 * @returns {object} Chart.js options
 */
export function getAvgSpendGuestChartOptions() {
  return {
    scales: {
      "y-axis-1": {
        type: "linear",
        display: true,
        position: "left",
      },
      "y-axis-2": {
        type: "linear",
        display: true,
        position: "right",
        grid: { drawOnChartArea: false },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            let label = context.dataset.label || "";
            if (label) label += ": ";
            const y = context.parsed.y;
            if (y != null) {
              label += y.toLocaleString(undefined, {
                maximumFractionDigits: 2,
              });
            }
            return label;
          },
        },
      },
    },
  };
}
